import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import Select from "react-select";
import BasicField from "../../../../utilsComponent/BasicField";
import LoadingPage from "../../../../reusableComponents/loader/loadingPage";
import { functionalities, PAGE_NAME_KEYS } from "../../../../consts";
import { getPathName, titleCase, viewModeOn } from "../../../../utilFunctions";
import { useLocation, useNavigate } from "react-router-dom";
import { getHealthPolicyStatus } from "../../ClaimIntimation/ClaimForm/helper";

const ClaimBasicDetails = ({ claimDetails, claimId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const claimDropdown = [
    { label: "Claim History", value: PAGE_NAME_KEYS.CLAIM_HISTORY, show: viewModeOn(functionalities.CLAIM_HISTORY) },
    { label: "Audit Trail", value: PAGE_NAME_KEYS.AUDIT_TRAIL, show: viewModeOn(functionalities.AUDIT_TRAIL) },
    // { label: "Claim Litigation", value: PAGE_NAME_KEYS.CLAIM_LITIGATION, show: claimDetails?.policyId && viewModeOn(functionalities.CLAIM_LITIGATION_PAGE) },
    // { label: "Manage Status ", value: PAGE_NAME_KEYS.MANAGE_STATUS, show: viewModeOn(functionalities.MANAGE_STATUS_PAGE) },
    // { label: "Remark/Request", value: PAGE_NAME_KEYS.REMARKS_REQUEST, show: viewModeOn(functionalities.REMARKS_REQUEST_PAGE) },
    { label: "Documents", value: PAGE_NAME_KEYS.DOCUMENTS, show: viewModeOn(functionalities.DOCUMENTS_PAGE) }
  ]
  const firstRowFields = [
    { label: "Claims ID", value: claimId, colProps: { md: 3, className: "ps-4" } },
    { label: "Policy Number", value: claimDetails?.policyId, colProps: { md: 3, className: "custom-word-wrap" } },
    { label: "Claim Handler", value: claimDetails?.claimHandler, colProps: { md: 3 } },
    { label: "Assigned To", value: claimDetails?.assignedTo, colProps: { md: 3 } },
  ];

  const secondRowFields = [
    { label: "Claim Status", value: claimDetails?.status, colProps: { md: 3, className: "ps-4" } },
    { label: "Claim Sub Status", value: claimDetails?.subStatus, colProps: { md: 3 } },
    { label: "Policy Status", value: getHealthPolicyStatus(claimDetails?.policyStatus), colProps: { md: 3 } },
  ];

  const navigateToTabs = (url) => {
    navigate('.', {
      state: {
        ...location.state,
        activeTab: url,
      },
      replace: true,
    });

  };

  const selectedValue = () => {
    let selectedValue = { label: "More Options", value: "" };
    if (location.state?.activeTab) {
      for (const element of claimDropdown) {
        if (element?.value === location.state?.activeTab) {
          selectedValue = element;
          break;
        }
      }
    }
    return selectedValue;
  };

  return (
    <div className="claim-details-bg">
      {loading ? (
        <div><loadingPage /></div>
      ) : (
        <>
          <Row>
            {firstRowFields.map((field) => (
              <Col key={field.label} {...field.colProps}>
                <BasicField label={field.label} value={field.value || "—"} />
              </Col>
            ))}
          </Row>
          <Row className="mt-3">
            {secondRowFields.map((field) => (
              <Col key={field.label} {...field.colProps}>
                <BasicField label={field.label} value={field.value || "—"} />
              </Col>
            ))}
            <Col md={3} className="container-index">
              <Select
                options={claimDropdown.filter((list) => list.show)}
                value={selectedValue()}
                placeholder="More Options"
                onChange={(e) => {
                  navigateToTabs(e.value);
                }}
              />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default ClaimBasicDetails;
